import { sdk } from '@/sdk';
import useSWR from 'swr';
import { SDKResponse } from '@commercetools/frontend-sdk';
import { CustomObjectPayload } from '@/sdk/composable-commerce-b2b/types/payloads/CustomObjectPayloads';

export const useCustomObjects = <T>(container: string, key: string): T | undefined => {
  const fetcher = async (): Promise<T> => {
    const res: SDKResponse<CustomObjectPayload> = await sdk.composableCommerce.customObject.getCustomObject({
      container,
      key,
    });
    if ('isError' in res && res.isError) throw new Error('Custom object fetch error');
    return res.data.value as T;
  };

  const { data, error } = useSWR(`/action/customObject/getCustomObject?container=${container}&key=${key}`, fetcher);

  return error ? undefined : data;
};
